import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import Vue from 'vue';

const ToastInstance = Vue.use(Toast);

export default ToastInstance;